import { Analytics } from 'packages';
import {
    POPULAR_CATEGORIES,
    CAROUSEL,
    PICKS_FOR_YOU,
    LAST_CHANCE,
    HEADER,
    INSTAGRAM_FEED,
    RECENTLY_VIEWED
} from './content-types';

const containerTypes = {
    [POPULAR_CATEGORIES]: 'Popcats',
    [CAROUSEL]: 'Carousel',
    [PICKS_FOR_YOU]: 'Picks for you',
    [LAST_CHANCE]: 'Last chance',
    [INSTAGRAM_FEED]: 'Instagram feed',
    [RECENTLY_VIEWED]: 'Recently viewed',
    [HEADER]: 'Header image'
};

export const trackContainerClick = (containerType, trackingId) => {
    Analytics.trackEvent({
        category: 'StartPage',
        action: `${containerTypes[containerType]}`,
        label: trackingId
    });
};
